<template>
	<div class="page">
		<top />
		<div style="width: 100%;height: 55px;"></div>
		<designer />
		<div class="home">
			<div @click="go('My')">我的主页</div>
			<div><</div>
					<div style="color: #E66617;">我的购物车</div>
			</div>
			<div class="orderList">
				<div class="orderList-content borderbottom">
				 <el-select v-model="type" placeholder="选择分区" style="width:40%;" @change="getUserCart">
						<el-option :label="item.typename" :value="item.id" v-for="(item,index) in cate" :key="index">
						</el-option>
					</el-select>
					<div class="orderList-list information">
						<div style="display: flex;align-items: center;">
							<el-checkbox v-model="checkAll" :indeterminate="isIndeterminate"
								@change="handleCheckAllChange"></el-checkbox>
							<div style="margin-left: 10px;">全选</div>
						</div>
						<div>价格</div>
						<div>操作</div>
					</div>
				</div>
				<div class="orderList-content">
					<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
						<el-checkbox  v-for="(item,index) in tableData" :label="item" :key="index">
							<div class="orderList-list content">
								<div @click="goDetail('Details', item.product_id)">
									<div style="display: flex;align-items: center;">

										<img :src="imageUrl(item.litpic)" alt="">
									</div>

									<div style="margin-top: 10px;margin-left: 20px;">编号<span style="margin-left: 5px;">{{ item.product_id }}</span></div>
								</div>
								<div class="money">￥{{ item.cost }}</div>
								<div class="confirm" @click="handleDelete(item.cart_id)">删除</div>
							</div>
						</el-checkbox>

					</el-checkbox-group>

					<div class="buy">
						<div>已选作品{{ num }}幅，合计<span style="color: #E66617;">￥{{ money }}.00</span></div>
						<div class="button">
							<div @click="del">删除</div>
							<div @click="isShow = true">立即购买</div>
							<div @click="down">一键下载</div>
						</div>
					</div>
				</div>
        <!-- 新增表单容器 -->
        <div v-if="formHTML" v-html="formHTML" style="display: none;"></div>
			</div>
			<!-- 购买弹框 -->
			<el-dialog title="提示" :visible.sync="isShow" width="80%"style="margin-top: 100px;" center>
				<div class="govip">确定结算吗？</div>
        <div class="offline">
          <!--  通联支付 -->
          <div @click="choose('tlwechat')">
            <img src="../../assets/wx1.png" alt="" v-if="selectedMethod === 'tlwechat'" />
            <img src="../../assets/wx2.png" alt="" v-else />
          </div>
          <div @click="choose('tlalipay')">
            <img src="../../assets/zfb1.png" alt="" v-if="selectedMethod === 'tlalipay'" />
            <img src="../../assets/zfb2.png" alt="" v-else />
          </div>
          <!--        <div @click="choose('tlunion')">-->
          <!--          <img src="../../assets/ysf1.png" alt="" v-if="selectedMethod === 'tlunion'" />-->
          <!--          <img src="../../assets/ysf2.png" alt="" v-else />-->
          <!--        </div>-->
          <div @click="choose('balance')">
            <img src="../../assets/balance1.png" alt="" v-if="selectedMethod === 'balance'" />
            <img src="../../assets/balance2.png" alt="" v-else />
          </div>
          <!--  end -->
        </div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="settle" style="background: #0086D9; border: none; width: 100px">确 定
					</el-button>
					<el-button @click="isShow = false" style="
			        background: #c92323;
			        color: #ffffff;
			        border: none;
			        width: 100px;
			      ">取 消</el-button>
				</span>
			</el-dialog>
			<info />
    <el-dialog
        :title="dialogTitle"
        :visible.sync="bounced"
        width="320px"
        :close-on-click-modal="isClose"
        center
        class="custom-pay-dialog"
    >
      <div class="qr-wrapper">
        <vue-qr
            :text="downloadData.url"
            :size="200"
            colorDark="#08243c"
            colorLight="#ffffff"
            :margin="10"
        ></vue-qr>
        <p class="tip-text">请长按二维码识别完成支付</p>
      </div>
    </el-dialog>
			<div style="width: 100%;height: 60px;background-color: #F6F6F6;"></div>
			<foot />
			<loading ref="loading"></loading>
		</div>
</template>

<script>
	import top from "../../components/common/header.vue";
	import foot from "../../components/common/footer.vue";
	import info from "../../components/common/qrCode.vue";
	import designer from "../../components/common/designer.vue";
	import Loading from "../../components/loading.vue";
  import {
    userCart,
    joinCart,
    cartSourceDetailorder,
    topCate,
    cartCheckUserOrder,
    cartCheckUserOrders,
    downloadArchives, checkOriginalAuth
  } from "../../request/api";
  import vueQr from "vue-qr";
  import {order_pay_polling, pay_tonglian, select_pay_method} from "../../../../ytht-pc/src/request/api";
	export default {
		components: {
			top,
			foot,
			designer,
			info,
			Loading,
      vueQr,
		},
		data() {
			return {
				tableData: [],
				multipleSelection: [],
				key_words: "", //作品名称编号搜索
				type: "", //所属区域
				count: 1,
				size: 999,
				page: 1,
				money: 0, //总价钱
				num: 0,
				shopActive: [],
				cate: '',
				checkAll: false,
				checkedCities:[],
				isIndeterminate: true,
				isShow:false,
        selectedMethod: "",
        dialogTitle: "打开微信扫一扫，向我付款", // 默认标题
        isWeChat: false,
        bounced: false, //充值弹框
        isClose: false,
        downloadData: {
          url: "扫码访问的链接地址",
          icon: "随便一张图片的地址也行",
        },
        orderInfo: {
          unified_id: "",
          unified_number: "",
        },
        formHTML: "", // 新增字段存储表单HTML
			};
		},

		created() {
			document.title = '以图绘图印花设计网-我的购物车';
			this.getCata()
			this.getUserCart()
      this.checkWeChatBrowser();
		},
		mounted() {
			this.$loading = this.$refs.loading
		},
		methods: {
      checkWeChatBrowser() {
        const userAgent = navigator.userAgent.toLowerCase();
        this.isWeChat = userAgent.indexOf('micromessenger') > -1;
      },
			handleCheckedCitiesChange(value) {
				this.money = 0
				this.shopActive = []
				this.multipleSelection = []
				console.log(value);
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.tableData.length;
				this.num = value.length
				value.forEach(a=>{
					this.money += Number(a.cost)
					this.shopActive.push(a.product_id)
					this.multipleSelection.push(a.cart_id)
				})
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableData.length;
			},
			handleCheckAllChange(val) {
				this.money = 0
				this.shopActive = []
				this.multipleSelection = []
				this.checkedCities = val ? this.tableData : [];
				this.isIndeterminate = false;
				this.checkedCities.forEach(a=>{
					this.money += Number(a.cost)
					this.shopActive.push(a.product_id)
					this.multipleSelection.push(a.cart_id)
				})
				this.num = this.checkedCities.length
			},
			getUserCart() {
				userCart({
					key_words: this.key_words,
					type: this.type,
					page: this.page,
					size: this.size,
				}).then((res) => {
					if (res.code == 200) {
						// console.log(res.data)
						this.tableData = res.data.cartInfo;
						this.count = res.data.count;
					}
				});
			},
			//获取顶部分区
			getCata() {
				topCate().then((res) => {
					// console.log(res);
					this.cate = res.data;
				});
			},
			go(url) {
				this.$router.push({
					name: url,
				});
			},
      goDetail(url, aid) {
        this.checkOriginalAuth(url, aid);
      },
      checkOriginalAuth(url, aid) {
        console.log(aid);
        checkOriginalAuth({
          aid: aid,
        }).then((res) => {
          console.log(res);
          if (res.code == 500) {
            this.$message({
              message: res.msg,
              type: "warning",
            });
            return;
          }
          if (res.code == 200) {
            this.$router.push({
              name: url,
              query: {
                aid: aid,
              },
            });
          }
        });
      },
      choose(method) {
        if (this.selectedMethod === method) {
          // 再次点击已选中的支付方式可取消选择
          this.selectedMethod = "";
        } else {
          this.selectedMethod = method;
        }
        if (this.selectedMethod === 'tlwechat') {
          this.dialogTitle = '打开微信扫一扫，向我付款';
        } else if (this.selectedMethod === 'tlalipay') {
          this.dialogTitle = '打开支付宝扫一扫，向我付款';
        } else if (this.selectedMethod === 'tlunion') {
          this.dialogTitle = '打开云闪付扫一扫，向我付款';
        } else {
          this.dialogTitle = '扫码支付';
        }
      },
      settle() {
        if(this.shopActive == '' || this.shopActive == null) return
        if (!this.selectedMethod) {
          this.$message.error("请选择支付方式");
          return;
        }
        cartSourceDetailorder({
          card_id: this.shopActive.toString(),
          payment: this.selectedMethod
        }).then((res) => {
          if (res.code == 200) {
            if (this.selectedMethod === 'balance') {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.isShow = false;
              this.$router.go(0)
            }else {
              this.orderInfo.unified_id = res.data.order_id;
              this.orderInfo.unified_number = res.data.order_code;
              pay_tonglian({
                unified_number: this.orderInfo.unified_number,
                transaction_type: 10,
                payment: this.selectedMethod
              }).then((res1) => {
                if (res1.code == 200) {
                  if (typeof res1.data == "string") {
                    // window.location.href = res.data;
                    if (this.isWeChat){
                      this.formHTML = res1.data; // 存储表单HTML
                      this.$nextTick(() => {
                        // 查找表单并提交
                        const form = document.getElementById('tongliansubmit');
                        if (form) form.submit();
                      });
                    }else {
                      this.isShow = false;
                      this.downloadData.url = res1.data;
                      this.bounced = true;
                      this.getSelect_pay_method();
                    }
                  }
                } else {
                  this.$message.error(res.msg);
                }
              });
            }
          }else if (res.code == 505) {
            this.$confirm(res.msg, {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
              this.$router.push("/data");
            })
          }else {
            this.$message.error(res.msg)
            this.isShow = false;
          }
        });
      },
      //支付接口列表
      getSelect_pay_method() {
        select_pay_method({
          unified_id: this.orderInfo.unified_id,
          unified_number: this.orderInfo.unified_number,
          transaction_type: 10,
          // pay_mark: "wechat",
          // pay_id: 1,
          pay_mark: "allinpay",
          pay_id: 3,
        }).then((res) => {
          if (res.code == 200) {
            this.order_pay();
          } else {
            this.$message.error(res.msg);
            this.bounced = false;
          }
        });
      },

      //订单支付轮询
      order_pay() {
        var time = setInterval(() => {
          order_pay_polling({
            unified_id: this.orderInfo.unified_id,
            unified_number: this.orderInfo.unified_number,
            transaction_type: 10,
            // pay_mark: "wechat",
            // pay_id: 1,
            pay_mark: "allinpay",
            pay_id: 3,
          }).then((res) => {
            console.log("222", res);
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.isShow = false;
              this.bounced = false;
              clearInterval(time);
              this.$router.go(0);
            }
          });
        }, 2000);
      },
			//结算

			settle1() {
			  if(this.shopActive == '' || this.shopActive == null) return

			    cartSourceDetailorder({
			      card_id: this.shopActive.toString(),
			    }).then((res) => {
					console.log(res);
			      if (res.code == 200) {
			        this.$message({
			          message: res.msg,
			          type: "success",
			        });
			        this.$router.go(0)
			      }else if (res.code == 505){
						this.$confirm(res.msg, {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						}).then(() => {
							this.$router.push("/data");
						})
				  }else {
			        this.$message.error(res.msg);
			      }
			    });
			},
			//单删
			handleDelete(row) {

			  joinCart({
			    cart_id: row,
			  }).then((res) => {
			    console.log(res);
			    if (res.code == 200) {
			      this.$message({
			        message: "操作成功",
			        type: "success",
			      });

			      this.getUserCart();
			    }
			  });
			},
			//多删
			del() {

			  if(this.multipleSelection == '') return
			  joinCart({
			    cart_id: this.multipleSelection.toString(),
			  }).then((res) => {
			    console.log(res);
			    if (res.code == 200) {
			      this.$message({
			        message: "操作成功",
			        type: "success",
			      });

			      this.getUserCart();
			    }
			  });
			},
			//使用免费次数一键下载
			down() {
				if(this.shopActive == '' || this.shopActive == null) return
				var that = this
				this.$loading.show()
				cartCheckUserOrder({
					card_id: this.shopActive.toString(),
				}).then((res) => {
					if (res.code == 300) {
						this.$confirm(res.msg, {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						}).then(() => {
							cartCheckUserOrders({
								card_id: this.shopActive.toString(),
							}).then((res) => {
								if (res.code == 200) {
									//下载
                  window.open("/api/newapi/BuyOrder/downloadArchives", "_self")
                  setTimeout(function(){
                    that.$message.success("开始下载");
                    that.$loading.hide()
                  },12000);
									// downloadArchives({
									// 	card_id: this.shopActive.toString(),
									// }).then((res) => {
									// 	const blob = new Blob([res]);
									// 	const fileName = '素材.zip';
									// 	if ("msSaveOrOpenBlob" in navigator) return window.navigator.msSaveOrOpenBlob(blob, fileName);
									// 	const blobUrl = window.URL.createObjectURL(blob);
									// 	const exportFile = document.createElement("a");
									// 	exportFile.style.display = "none";
									// 	exportFile.download = fileName;
									// 	exportFile.href = blobUrl;
									// 	document.body.appendChild(exportFile);
									// 	exportFile.click();
									// 	// 去除下载对 url 的影响
									// 	document.body.removeChild(exportFile);
									// 	window.URL.revokeObjectURL(blobUrl);
									// 	this.$message.success("下载完成");
									// 	this.$loading.hide()
									// });
								}else{
									this.$message.error(res.msg);
									this.$loading.hide()
								}
							});
						}).catch(() => {
						  this.$loading.hide()
						});
					}else if (res.code == 505){
						this.$loading.hide()
						this.$confirm(res.msg, {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						}).then(() => {
							this.$router.push("/data");
						})
					}else{
						this.$message.error(res.msg);
						this.$loading.hide()
					}
				});
			},
		},
	};
</script>

<style lang="less">
	.page {
		background: #F6F6F6;

		.home {
			padding: 0 20px;
			display: flex;
			align-items: center;
			font-size: 13px;

			div {
				margin-right: 7px;
			}
		}

		.orderList {
			margin-top: 15px;
			padding: 0 10px;

			.orderList-content {
				padding: 18px 12px;

				font-size: 13px;
				background-color: #FFFFFF;
				color: #000000;
			}

			.borderbottom {
				border-bottom: 1px solid #ECECEC;
			}

			.orderList-list {
				display: flex;
				align-items: center;
				justify-content: space-between;

				img {
					margin-left: 10px;
					width: 100px;
					height: 100px;
				}

				.money {
					position: absolute;
					left: 55%;
					transform: translateX(-55%)
				}
			}

			.information {
				margin-top: 16px;
				padding-right: 20px;
			}

			.content {
				width: 300px;
				border-bottom: 1px solid #EFEFEF;
				padding-bottom: 15px;
				margin-bottom: 15px;
				color: #08243C;

				.confirm {
					color: #C92323;
					border-radius: 12px;
					padding: 6px 21px;
					font-size: 12px;
					border: 1px #C92323 solid;
				}
			}

			.buy {
				margin-top: 20px;
				text-align: right;

				.button {
					margin-top: 23px;
					display: flex;
					flex-direction: row-reverse;

					div:last-child,div:nth-child(2) {
						margin-right: 12px;
						width: 75px;
						height: 26px;
						background-color: #E66617;
						color: #FFFFFF;
						line-height: 26px;
						text-align: center;
						border-radius: 3px;
					}

					div:first-child {
						width: 65px;
						height: 24px;
						border: 1px solid #C92323;
						color: #C92323;
						line-height: 26px;
						text-align: center;
						border-radius: 3px;
					}
				}
			}
		}
		.govip {
			font-size: 13px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #000000;
			text-align: center;
			margin-top: 15px;
		}

	}
	.el-message-box {
	  width: 80%;
	}
  .offline {
    //padding: 12px;
    //font-size: 12px;
    background-color: #ffffff;
    //color: #08243c;
    display: flex;
    padding-top: 12px;

    //div:first-child {
    //  width: 25%;
    //}

    .money {
      margin-left: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;

      .inputMoney {
        display: flex;
        align-items: center;

        input {
          width: 72px;
          height: 28px;
          border: 1px #cdd6de solid;
          text-align: center;
        }
      }

      .fixed {
        width: 75px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border: 1px #cdd6de solid;
        margin-bottom: 9px;
      }

      .num-active {
        background: #f6f8f9;
      }
    }

    img {
      width: 33px;
      height: 33px;
    }
  }
</style>
<style lang="less" scoped>
/* 自定义弹框样式 */
.custom-pay-dialog {
  // 标题样式
  .el-dialog__title {
    color: #08243c; // 主题深蓝色
    font-weight: bold;
  }

  // 内容区域
  .qr-wrapper {
    text-align: center;
    padding: 10px 0;

    .tip-text {
      margin-top: 15px;
      color: #666;
      font-size: 12px;
    }
  }

  // 关闭按钮
  .el-dialog__headerbtn {
    top: 12px;
    right: 12px;
    .el-icon-close {
      color: #999;
      &:hover {
        color: #e66617; // 主题橙色
      }
    }
  }
}
</style>
